{
	"deleteGuest": "Delete guest",
	"excludeGuest": "Delete guest",
	"deleteDescription": "The guest will be permanently deleted. Do you want to continue anyway?",
	"emptyText": "No data to display.",
	"reports": {
		"goTo": "go to",
		"clientsReportTable": {
			"filename": "consumption-per-customer",
			"title": "Consumption per customer",
			"name": "Name",
			"phone": "Phone",
			"zigCode": "ZigCode",
			"cpf": "CPF",
			"appTransactionsValue": "Paid by app",
			"bonusTransactionsValue": "Paid with bonus",
			"housePostPaidTransactionsValue": "Post paid in the house",
			"housePrePaidTransactionsValue": "Prepaid in the house",
			"total": "Total",
			"hasApp": "Has app",
			"noApp": "Don't have app",
			"seeExtract": "See extract",
			"editData": "Edit data",
			"invoices": "Invoices",
			"searchClient": "Search for a client here",
			"customerConsumption": "Consumption per customer",
			"empty": "No data to display."
		},
		"cmvReportTable": {
			"mountableCaps": "MOUNTABLE",
			"mountable": "Product mountable",
			"name": "Name",
			"section": "Section",
			"count": "Quantity",
			"productUnitCost": "Unit cost",
			"total": "Total cost"
		},
		"rappiDiscount": {
			"products": "Products",
			"date": "Date",
			"value": "Discount value",
			"employee": "Employee who applied the discount",
			"emptyText": "No data to display."
		},
		"reserveReportTable": {
			"title": "Package details",
			"downloadTable": "Download Table",
			"confirmedPeople": "{{value}} confirmed customers",
			"ticketTooltip": "Average ticket from package customers",
			"total": "Total billing",
			"reserveValue": "billed in package value",
			"totalProductsValue": "billed on products",
			"tips": "tips",
			"issuedInvoices": "Issuance of invoice",
			"name": "Name",
			"count": "Qty.",
			"unitValue": "Unitary value",
			"totalValue": "Total value",
			"discount": "Discount",
			"receivedValue": "Received amount",
			"noPromotion": "Products out of promotion",
			"discountTooltip": "Any discounts on the account are part of this value",
			"productName": "Total",
			"packageName": "Package name",
			"date": "Package date",
			"products": "Products",
			"invitedPeople": "Guests",
			"confirmedPeopleExcel": "Confirmed",
			"value": "Vackage value",
			"revenue": "Invoicing",
			"issued": "Invoice issuance",
			"titleExcel": "packages",
			"filenameExcel": "packages",
			"promotionName": "Promotion",
			"productNameExcel": "Product",
			"selledCount": "Quantity",
			"titleExcelDetails": "package details ",
			"filenameExcelDetails": "package_details_"
		},
		"stockReportTable": {
			"title": "Stock transfers",
			"category": "Transfers from {{product}}",
			"bar": "Bar",
			"time": "Time",
			"stocker": "Stocker",
			"employeeBar": "Bar employee",
			"quantity": "Quantity"
		},
		"cashierAdjustmentsReport": {
			"title": "Bleedings and Petty Cash",
			"filters": {
				"byAuthor": {
					"label": "Filter by Employee",
					"placeholder": "Select a employee"
				},
				"byCashier": {
					"label": "Filter by Cashier",
					"placeholder": "Select a cashier"
				},
				"byType": {
					"label": "Filter by Type",
					"placeholder": "Select a type"
				}
			},
			"table": {
				"columns": {
					"author": "Employee",
					"cashier": "Cashier",
					"timestamp": "Date/Hour",
					"type": "Type",
					"obs": "Observation",
					"value": "Value"
				}
			},
			"adjustmentTypes": {
				"bleeding": "Bleeding",
				"pettyCash": "Petty Cash"
			},
			"cashierAdjustmentForm": {
				"inputLabels": {
					"value": "Value",
					"obs": "Observation"
				},
				"errors": {
					"emptyValue": "Type a value"
				}
			},
			"cashierAdjustmentModal": {
				"title": "Add {{adjustmentType}}",
				"notAllowedText": "This action cannot be performed when the event has already ended."
			},
			"excelFileName": "cashier-adjustments-{{timestamp}}",
			"successfullExportMsg": "Spreadsheet exported successfully!",
			"exchangeTotal": "Total in change fund",
			"cashWithdrawal": "Total in withdrawal"
		}
	}
}
